module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Account-Creation_03-0920afc2c29326992af43ca98ac520f7.jpg";